import { ToggleTrack, Segment } from "./styled";

function SegmentedToggle({ className, options, value, onChange }) {
  return (
    <ToggleTrack className={className}>
      {options.map((option) => (
        <Segment
          key={option.value}
          isActive={value === option.value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Segment>
      ))}
    </ToggleTrack>
  );
}

export default SegmentedToggle;
